import React from 'react'
import './subExemplo.scss'
import { FaIndustry, FaNetworkWired, FaChalkboardTeacher } from "react-icons/fa";

export default function SubMenuExemplo() {
  return (
    <div className="container-submenuExemplo">
      <div className="submenu-Exemplo">
        <div className="porsetor">
          <div className="title-porsetor">
            <h1><FaIndustry /> Por Setor</h1>
          </div>
          <a href="#" style={{color: "#00000052"}}>
            <p>Varejo</p>
          </a>
          <a href="#" style={{color: "#00000052"}}>
          <p>Saúde</p>
          </a>
          <a href="#" style={{color: "#00000052"}}>
            <p>Acadêmicos</p>
          </a>
          <a href="#" style={{color: "#00000052"}}>
            <p>Hospitalidade</p>
          </a>
        </div>
        <div className="pordepart">
          <div className="title-pordepart">
            <h1><FaNetworkWired /> Por Departamento</h1>
          </div>
          <p style={{color: "#00000052"}}>Vendas</p>
          <p style={{color: "#00000052"}}>Marketing</p>
          <p style={{color: "#00000052"}}>Financeiro</p>
          <p style={{color: "#00000052"}}>Recursos Humanos</p>
          <p style={{color: "#00000052"}}>Gestão de Projetos</p>
        </div>
        <div className="pelouso">
          <div className="title-pelouso">
            <h1><FaChalkboardTeacher /> Pelo Uso</h1>
          </div>
          <p style={{color: "#00000052"}}>Mobile</p>
          <p style={{color: "#00000052"}}>Desempenho</p>
          <p style={{color: "#00000052"}}>Diversos</p>
          <p style={{color: "#00000052"}}>Dashboards Divertidos</p>
        </div>
      </div>
    </div>
  )
}
